import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import Conf from '../../../config/config.js';

const styles = (theme) => ({
});

const ExPanelSummary = withStyles((theme) => ({
  root: {
    'padding': '5px 5px 5px 10px !important',
    'height': '18px',
    'backgroundColor': '#e8f5e9',
    'minHeight': '50px',
    '&$expanded': {
      minHeight: '50px',
    },
  },
  expanded: {
    padding: '12px 0 12px 0px',
  },
  expandIcon: {
    padding: '0',
  },
}))(AccordionSummary);

const ExPanel = withStyles((theme) => ({
  expanded: {
    margin: '0',
  },
}))(Accordion);

const ExPanelDetail = withStyles((theme) => ({
  root: {
    padding: '10px',
    display: 'block',
  },
}))(AccordionDetails);


class Help extends React.Component {
  render() {
    return (
      <div>
        <Typography sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '30px 10px 16px 10px',
        }}>
        xxx
        </Typography>
        <Card sx={{margin: '10px 20px 10px 20px'}}>
          <ExPanel>
            <ExPanelSummary expandIcon={<ExpandMoreIcon />} >
              <Typography>xxx</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>xxx</Typography>
            </ExPanelDetail>
          </ExPanel>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(Help);
